<template>
  <div>
    <el-upload :limit="1" class="avatar-uploader" :action="action" :headers="headers" :show-file-list="false" :on-success="handleAvatarSuccess" :on-error="handleAvatarError">
      <img v-if="imageUrl" :src="imageUrl" style="width: 200px" />
      <i v-else class="el-icon-plus avatar-uploader-icon"></i>
    </el-upload>
  </div>
</template>

<script>
import _ from 'lodash'
import {update} from 'lodash'
export default {
  props: {
    value: {
      type: [Object, Array, String, Number, Boolean],
      default: null
    }
  },

  data() {
    return {
      headers: {
        domain: process.env.VUE_APP_BASE_API
      },
      action: process.env.VUE_APP_BASE_API + '/api/user/up_file',
      imageUrl: this.value
    }
  },
  watch: {
    value(newVal) {
      this.imageUrl = newVal
    },
    imageUrl(newVal) {
      if (!this.isEqual(newVal, this.value)) {
        this.$emit('input', _.cloneDeep(newVal)) // 值变化时通知父级
        this.update_func()
      }
    }
  },
  created() {},
  methods: {
    isEqual(a, b) {
      // 智能值比对（处理所有数据类型）
      if (typeof a !== typeof b) return false
      if (typeof a === 'object' && a !== null && b !== null) {
        // 处理引用类型
        return _.isEqual(a, b) // 使用 lodash 深度比对
      }
      return a === b // 基本类型直接比对
    },
    update_func() {
      this.$emit('change', true)
    },
    handleAvatarError(e) {
      console.log(e)
    },
    handleAvatarSuccess(res, file) {
      this.imageUrl = res
      //   console.log(res)
    }
  }
}
</script>

<style lang="scss" scoped>
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  //   cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  text-align: center;
}
.avatar {
  width: 178px;
}
</style>

